export function Lock() {
  return (
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 13.5V9C12 5.68629 14.6863 3 18 3C21.3137 3 24 5.68629 24 9V13.5H25.5C27.1569 13.5 28.5 14.8431 28.5 16.5V28.5C28.5 30.1569 27.1569 31.5 25.5 31.5H10.5C8.84315 31.5 7.5 30.1569 7.5 28.5V16.5C7.5 14.8431 8.84315 13.5 10.5 13.5H12ZM21 9V13.5H15V9C15 7.34315 16.3431 6 18 6C19.6569 6 21 7.34315 21 9Z" fill="currentColor"/>
    </svg>
  );
}